/**
 * Converts a boolean-like value into a readable "Yes" or "No" string.
 *
 * @param {boolean|string|number|null} point - The input value to interpret.
 * @returns {string} "Yes", "No", or "Not provided".
 *
 * @description
 * Supports boolean, numeric (1/0), and string ("true"/"false") representations.   
 */
export const booleanDataPointFormatter = (point) => {
    if (point === true || point === "true" || point === 1) {
        return "Yes"
    } else if (point === false || point === "false" || point === 0) {
        return "No"
    } else {
        return "Not provided"
    }
}

/**
 * Determines directional tendency based on numeric variation.
 *
 * @param {number} variation - Numeric delta to evaluate.
 * @returns {"up"|"down"|"flat"} The corresponding trend description.
 *
 * @description
 * Interprets small positive or negative changes as "up" or "down".  
 * Variations below ±0.001 are considered "flat".
 */
export const tendencyFormatter = (variation) => {
    if (variation > 0.001) {
        return "up"
    } else if (variation < -0.001) {
        return "down"
    } else {
        return "flat"
    }
}